const C_COMMISSION_RENT_ID = {
  one_month: 1,
  two_months: 2
};
const C_COMMISSION_RENT_ALL = {
  one_month: {
    name: "Alquiler 1 año (Comisión de 1 mes)",
    id: C_COMMISSION_RENT_ID.one_month,
    value: C_COMMISSION_RENT_ID.one_month,
    label: "Alquiler 1 año (Comisión de 1 mes)"
  },
  two_months: {
    name: "Alquiler de 3 a 5 años (Comisión de 2 meses)",
    id: C_COMMISSION_RENT_ID.two_months,
    value: C_COMMISSION_RENT_ID.two_months,
    label: "Alquiler de 3 a 5 años (Comisión de 2 meses)"
  }
};

const A_COMMISSION_RENT_ALL = [
  C_COMMISSION_RENT_ALL.one_month,
  C_COMMISSION_RENT_ALL.two_months
];

const O_COMMISSION_RENT_ALL = {
  [C_COMMISSION_RENT_ID.one_month]: C_COMMISSION_RENT_ALL.one_month,
  [C_COMMISSION_RENT_ID.two_months]: C_COMMISSION_RENT_ALL.two_months
};

export {
  C_COMMISSION_RENT_ID,
  C_COMMISSION_RENT_ALL,
  A_COMMISSION_RENT_ALL,
  O_COMMISSION_RENT_ALL
};
